var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 68,
    viewBox: "0 0 65 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6477_16915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 55,
    height: 58,
    rx: 8,
    fill: "#00B6CE",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 56,
    height: 59,
    rx: 8.5,
    stroke: "#DDDDDD",
    strokeOpacity: 0.866667,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3506 24.1719V46.3546H33.3549V24.1719H33.3506Z",
    fill: "#F1FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3276 29.3125H43.0229V30.0469H39.3276V29.3125ZM39.3276 35.1875H43.0229V35.9219H39.3276V35.1875ZM20.5503 17.5625H24.2456V18.2969H20.5503V17.5625ZM26.9999 17.5625H30.6952V18.2969H26.9999V17.5625ZM20.5503 23.4329H24.2456V24.1673H20.5503V23.4329ZM26.9999 23.4329H30.6952V24.1673H26.9999V23.4329ZM20.5546 29.3309H24.2499V30.0652H20.5546V29.3309ZM26.9999 29.3171H30.6952V30.0515H26.9999V29.3171Z",
    fill: "#F1FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6145 38.8312C27.1031 38.285 26.3941 37.9453 25.6164 37.9453C24.0609 37.9453 22.7891 39.3039 22.7891 40.9654V46.3539H23.6484V40.9654C23.6484 40.4055 23.8547 39.8822 24.2285 39.4829C24.6023 39.0836 25.0965 38.8633 25.6164 38.8633C26.1406 38.8633 26.6305 39.0836 27.0043 39.4829C27.3781 39.8822 27.5844 40.4101 27.5844 40.9654V46.3539H28.4438V40.9654C28.4438 40.1347 28.1258 39.3819 27.6145 38.8312Z",
    fill: "#F1FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2416 26.1875V46.2864H35.2459V26.1875H35.2416Z",
    fill: "#F1FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 46.3563V24.1736H35.2457V11.625H16V46.3563H13.25V48.3759H51.75V46.3563H49ZM33.3551 46.3563H17.8906V13.6445H33.3551V46.3563ZM47.1094 46.2875H35.2414V26.1932H47.1094V46.2875Z",
    fill: "#F1FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6477_16915",
    x: 0,
    y: 0,
    width: 65,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.317647 0 0 0 0 0.396078 0 0 0 0.101961 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6477_16915"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6477_16915",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/CompanyIcon.0e58a491f0124464e7b38922e130e73d.svg";
export { ForwardRef as ReactComponent };